//@flow
import {ColorContrastTools} from "./ColorContrastTools";

let x = $;
/*
 * Digital Purchase Order
 *
 * Copyright (c) 2017 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow

import DOMPurify from "dompurify";
import {safeRead} from "./misc-functions";

$.views.helpers({
	//@flow
	colorContrastRatio: (color1 : string, color2: string) => ColorContrastTools.contrastRatio(color1, color2),
	colorSelectContrastColor: (baseColor: string, contrastColor1 : string, contrastColor2: string) => ColorContrastTools.selectContrastColor(baseColor, contrastColor1, contrastColor2),
	colorGetContrastText: (baseColor : string) => ColorContrastTools.getContrastText(baseColor),
	currentUser: () => API.User,
	mergeClasses: function() {
		if (arguments.length == 0) {
			return '';
		}

		return Array.prototype.slice.call(arguments).join(' ');
	},
	concat: function(separator, ...values) {
		values = values.filter((v) => !stringEmpty(v));

		return values.join(separator);
	},
	joinArray: function (values, separator, onEmpty) {
		values = values.filter((v) => !stringEmpty(v));

		if (!values.length && !stringEmpty(onEmpty)) {
			return onEmpty;
		}
		return values.join(separator);
	},
	globalizeCalendarPattern: function() {
		var finalPattern = '';
		for (var i = 0; i < arguments.length; i++) {
			var pattern = arguments[i];

			if (pattern.length != 1 || !Globalize.culture().calendar.patterns[pattern]) {
				finalPattern += pattern;
			} else {
				finalPattern += Globalize.culture().calendar.patterns[pattern];
			}
		}

		return finalPattern;
	},
	formatDate: function(date, format) {
		return Globalize.format(date, format);
	},
	formatCurrency: function(value, ISO) {
		return Currency.format(value, ISO);
	},
	IsNotEmpty: function(value) {
		if (value === null || typeof value === 'undefined' || (typeof value === 'string' && value.trim().length == 0)) {
			return false;
		}

		return true;
	},
	fileIconV2: function(mimeType) {
		if (mimeType) {
			switch (mimeType.toLowerCase()) {
				case 'image/jpg':
				case 'image/jpeg':
					return 'file-icon file-icon-jpg';
					break;
				case 'image/png':
					return  'file-icon file-icon-png';
					break;
				case 'application/pdf':
					return 'file-icon file-icon-pdf';
					break;
				case 'text/xml':
					return 'file-icon file-icon-xml';
					break;
			}
		}

		return 'file-icon file-icon-default';
	},
	fileIcon: function(mimeType) {

		if (mimeType.substring(0,5) == 'image') {
			return 'fa fa-file-image-o';
		} else if (mimeType.substring(0,5) == 'text') {
			return 'fa fa-file-text-o';
		} else if (mimeType.substring(0,5) == 'video') {
			return 'fa fa-file-video-o';
		} else if (mimeType.substring(0,5) == 'audio') {
			return 'fa-file-audio-o';
		} else {


			switch (mimeType) {
				case 'application/pdf':
				case 'application/postscript':
					return 'fa-file-pdf-o';
					break;
				case 'application/zip':
				case 'application/x-gtar':
				case 'application/x-tar':
				case 'application/gzip':
					return 'fa-file-archive-o';
					break;
				case 'application/msexcel':
				case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
				case 'application/vnd.msexcel':
				case 'application/vnd.ms-excel.sheet.macroEnabled.12':
					return 'fa-file-excel-o';
					break;

				case 'application/msword':
				case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
				case 'application/vnd.ms-word.document.macroEnabled.12':
				case 'application/vnd.msword':
					return 'fa-file-word-o';
					break;
				case 'application/mspowerpoint':
				case 'application/vnd.mspowerpoint':
				case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
				case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
				case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
					return 'fa-file-powerpoint-o';
					break;
				default:
					return 'fa-file-o';
			}
		}
	},
});

$.views.converters({
	purify: (value) => DOMPurify.sanitize(value),
	mailto: function(value) {
		let urlValue = 	$.views.converters.url(value);

		return 'mailto:' + urlValue;
	},
	nl2space: function(value) {
		if (!value) return null;
		return value.replace(new RegExp('(s*(\n|\r|\r\n))+', 'g'), ' ');
	},
	nl2spaceHtml: function(value) {
		return $.views.converters.nl2space($.views.converters.html(value));
	},
	nl2br: function (value) {
		var htmlValue = $.views.converters.html(value);
		return htmlValue.replaceAll('\n', '<br>');
	},
	boolToStr: function(value, context) {
		let nullable = safeRead(this,  'tagCtx.props.nullable' );

		if (typeof(nullable) == 'undefined') {
			nullable = false;
		}

		if (nullable && (value === null || value === undefined) ) {
			return "";
		}
		return (value ? "true":"false");
	},
	strToBool: function(value, context) {
		let nullable = safeRead(this,  'tagCtx.props.nullable' );

		if (typeof(nullable) == 'undefined') {
			nullable = false;
		}

		if (nullable && (value === null || value == "")) {
			return null;
		}
		return ($.trim(value) == "true");
	},
	floatToStr: function(value, context) {
		if (value !== 0 && (value == "" || !value)) {
			return null;
		}

		value = parseFloat(value);

		var maxPrecision = this.linkCtx.elem.getAttribute('data-precision') || 2;
		var minPrecision = this.linkCtx.elem.getAttribute('data-min-precision') || 0;

		return Globalize.format(value, Globalize.getNumberFormat(value, {
			MinimumFractionDigits: minPrecision,
			MaximumFractionDigits: maxPrecision
		}));

		// return Globalize.format(value, "n" + precision);
	},
	strToFloat: function(value, context) {
		let nullable = safeRead(this,  'tagCtx.props.nullable' );

		if (typeof(nullable) == 'undefined') {
			nullable = true;
		}
		if (value == "") {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		var float = Globalize.parseFloat(value);

		if (isNaN(float)) {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		return float;
	},
	unixtime2ShortDate: function(value, context) {
		return Globalize.format(new Date(value * 1000), 'd');

	},
	shortDate2unixtime: function(value, context) {
		var date = Globalize.parseDate(value, 'd');

		return date.getTime() / 1000;
	},
	date2string: function(value) {
		if (!value || !(value instanceof Date)) {
			return null;
		}
		// var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		let format = safeRead(this,  'tagCtx.props.format', Globalize.culture().calendar.patterns.d, true );
		return Globalize.format(value, format);
	},

	string2date: function(datestr: string) {
		if (!datestr) {
			return null;
		}

		if (datestr.slice(-1) == 'Z') {
			datestr = datestr.substring(0, datestr.length - 1) + '+00:00';
		}

		// let format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		let format = safeRead(this,  'tagCtx.props.format', Globalize.culture().calendar.patterns.d, true );

		if (datestr.includes('T')) {
			datestr = datestr.replace('T',' ');
		}

		if (format.includes('T')) {
			format = format.replace('T',' ');
		}

		/** @type Date */
		let date = Globalize.parseDate(datestr, format);

		if (!date) {
			return null;
		}

		// let time = this.tagCtx.props.time;
		let time = safeRead(this,  'tagCtx.props.time');

		if (time) {
			let [hour, minute, second] = time.split(':');
			date.setHours(hour, minute, second);
		}

		return date;
	},
	iso8601ToHtmlInput: function(isodate: string) {
		if (!isodate) {
			return null;
		}

		if (isodate.slice(-1) == 'Z') {
			isodate = isodate.substring(0, isodate.length - 1) + '+00:00';
		}

		// convert iso8601 date into date object
		let date = Globalize.parseDate(isodate, 'yyyy-MM-ddTHH:mm:sszzz');

		// determine target date format
		let format = safeRead(this,  'tagCtx.props.format', Globalize.culture().calendar.patterns.d, true );

		if (format.includes('T')) {
			format = format.replace('T',' ');
		}

		return Globalize.format(date, format);
	},
	htmlInputToIso8601: function(datestr: string) {
		if (!datestr) {
			return null;
		}

		// use existing string2date function to get an actual date object
		let date = $.views.converters.string2date.call(this, datestr);

		if (!date) {
			return null;
		}

		return date.toISO8601String();
	},
	apidate2string: function(value) {
		if (!value) {
			return null;
		}
		// var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		let format = safeRead(this,  'tagCtx.props.format', Globalize.culture().calendar.patterns.d, true );

		var date = null;

		if (value.Timestamp) {
			date = new Date(value.Timestamp * 1000)
		}

		if (!date) {
			return null;
		}

		return Globalize.format(date, format);

	},
	string2apidate: function(datestr) {
		if (!datestr) {
			return null;
		}
		// var format = this.tagCtx.props.format || Globalize.culture().calendar.patterns.d;
		let format = safeRead(this,  'tagCtx.props.format', Globalize.culture().calendar.patterns.d, true );
		var date = Globalize.parseDate(datestr, format);

		if (!date) {
			return null;
		}

		return {
			Timestamp: date.getTime() / 1000,
			Formatted:  Globalize.format(date, Globalize.culture().calendar.patterns.d + ' ' + Globalize.culture().calendar.patterns.t)
		};
	},
	setBit: function(value) {
		// "Convert Back": If checked, set this bit on the data,
		// or if unchecked, unset this bit on the data
		var mask = 1 << this.linkCtx.elem.getAttribute("data-bit"),
			// Shift first bit, 0, 1 or 2 bits to the left,
			// to create a mask
			dataValue = this.tagCtx.args[0];
		// Take the current data value
		return value ? (dataValue | mask) : (dataValue & ~mask);
		// Use the mask to set or unset that bit on the data,
		// and return the modified value
	},
	getBit: function(value) {
		// "Convert": Get the bit from the data,
		// and check or uncheck the checkbox
		return (value >>
			this.linkCtx.elem.getAttribute("data-bit") & 1) === 1;
		// Shift 0, 1 or 2 bits to the right,
		// and see if the first bit is set.
	},
	toNum: function (val) {
		if (/^\s*$/.test(val)) {
			return null;
		}

		return +val;
	},
	trim: function (val) {
		if (/^\s*$/.test(val)) {
			return null;
		}

		return val.trim();
	},
	toInt: function(value) {
		let nullable = safeRead(this,  'tagCtx.props.nullable' );

		if (typeof(nullable) == 'undefined') {
			nullable = true;
		}
		if (value == "") {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		let int = Globalize.parseInt(value);

		if (isNaN(int)) {
			if (nullable) {
				return null;
			} else {
				return 0;
			}
		}

		return int;
	},
	/*mergeclass: function(value, context) {
		var elem =$(context.tgt);
		var toggleClasses = (elem.attr('data-merge-class') ? elem.attr('data-merge-class').split(' '):[]);
		var classes = elem.attr('class');


		$.each(toggleClasses, function(index, cls) {
			if (cls.trim().length > 0) {
				if (value) {
					// add class
					if (classes.indexOf(cls) < 0) {
						classes = classes + ' ' + cls;
					}
				} else {
					if (classes.indexOf(cls) > -1) {
						classes.replace(cls,'');
					}
				}
			}
		});
		return classes;
	},*/
	isInArray: function(value, context) {
		// "Convert": check whether item is in given array
		var ctrlValue = this.linkCtx.elem.value; //context.tgt.value;
		return ($.inArray(ctrlValue, value) !== -1);
	},
	addToArray: function(value, context) {
		// "Convert Back": add value to Array if set, otherwise remove

		if (!Array.isArray(this.tagCtx.args[0])) {
			this.tagCtx.args[0] = [];
		}

		var arr = this.tagCtx.args[0];
		var itemValue = this.linkCtx.elem.value;

		if (value) {
			// add to array
			if($.inArray(itemValue, arr) === -1) {
				$.observable(arr).insert(itemValue);
				// arr.push(itemValue);
			}
		} else {
			var pos = $.inArray(itemValue, arr);

			if (pos !== -1) {
				$.observable(arr).remove(pos,  1);
				// arr.splice(pos,1);
			}

		}
		return arr;
	},
	arrayFirstValue: function(value, context) {
		// "Convert": check whether item is in given array
		if (!Array.isArray(value) || (value.length == 0)) {
			return null;
		}
		return value[0];
	},
	toSingleArray: function(value, context) {
		// "Convert Back": add value to Array if set, otherwise remove
		var arr = this.tagCtx.args[0];
		var itemValue = this.linkCtx.elem.value;

		if (value) {
			return [itemValue];
		} else {
			return[];

		}
	},

	getTranslation: function(val, arg1) {

		// let nl2space = this.tagCtx.props.nl2space;
		let nl2space = safeRead(this,  'tagCtx.props.nl2space');

		if (!Array.isArray(val)) {
			return null;
		}

		// get language ID to retrieve
		var languageID = this.linkCtx.elem.getAttribute("data-language-id");
		var prop = this.linkCtx.elem.getAttribute("data-language-prop");

		if (!prop) {
			prop = 'Text';
		}
		// find translation object
		var translObj = val.filter(function(item) {
			return item.LanguageID == languageID;
		});

		if (!translObj || !translObj.length) {
			return null;
		}

		translObj = translObj[0];

		if (nl2space && translObj[prop]) {
			return translObj[prop].replaceAll('\n',' ');
		}
		return translObj[prop];
	},
	setTranslation: function(val, arg1) {
		if (!Array.isArray(this.tagCtx.args[0])) {
			this.tagCtx.args[0] = [];
		}

		// get language ID to retrieve
		var languageID = this.linkCtx.elem.getAttribute("data-language-id");
		let prop = this.linkCtx.elem.getAttribute("data-language-prop");


		if (!prop) {
			prop = 'Text';
		}

		var arr = this.tagCtx.args[0];

		// find translation object
		var translObj = arr.filter(function(item) {
			return item.LanguageID == languageID;
		});

		if (!translObj || !translObj.length) {
			translObj = {
				LanguageID: languageID,
			};

			translObj[prop] = null;
		} else {
			translObj = translObj[0];
		}

		// translObj[prop] = val
		$.observable(translObj).setProperty(prop, val);

		if (val) {
			// add to array
			if($.inArray(translObj, arr) === -1) {
				// arr.push(translObj);
				$.observable(arr).insert(translObj);
			}
		} else {
			// remove from array
			var pos = $.inArray(translObj, arr);

			if (pos !== -1) {
				// arr.splice(pos,1);
				$.observable(arr).remove(pos, 1);
			}

		}

		// let triggerRefresh = this.tagCtx.props.doRefresh;
		try {
			this.linkCtx.view.refresh();
		} catch(e){}
		return arr;
	},
	decorate: function(value) {
		// let prepend = this.tagCtx.props.prepend || '';
		// let append = this.tagCtx.props.append || '';
		let prepend = safeRead(this,  'tagCtx.props.prepend', '', true );
		let append = safeRead(this,  'tagCtx.props.append', '', true );

		if (!value) {
			return value;
		}

	    return prepend + value  +  append;
	},
	join: function (...values) {
		// let separator = this.tagCtx.props.separator || undefined;
		// let onEmpty = this.tagCtx.props.onEmpty || undefined;

		let separator = safeRead(this,  'tagCtx.props.separator');
		let onEmpty = safeRead(this,  'tagCtx.props.onEmpty');

		values = values.filter((v) => !stringEmpty(v));

		if (!values.length && !stringEmpty(onEmpty)) {
			return onEmpty;
		}
		return values.join(separator);

	}
});

export {x}
